import Yup from "../validationsLib";

/**
 * Validations rules for the setting page
 */

export default Yup.object().shape({
    first_name: Yup.string()
        .matches(
            /^[aA-zZ\s]+$/,
            "First name cannot have numbers & special characters."
        )
        .max(30, "User should not enter more than 30 characters in this field.")
        .required("First name cannot be blank!"),

    last_name: Yup.string()
        .matches(
            /^[aA-zZ\s]+$/,
            "Last name cannot have numbers & special characters."
        )
        .max(30, "User should not enter more than 30 characters in this field.")
        .required("Last name cannot be blank!"),

    email: Yup.string()
        .email("Please enter a valid email address")
        .required("Email cannot be blank!"),
    organization_name: Yup.string()
            .required("Please enter organisation name!")
    // password: Yup.string()
    //     .matches(
    //         /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{8,32}$/,
    //         "Password should contains 8-32 characters. At least 1 digit, 1 special character, 1 uppercase letter & 1 lowercase letter."
    //     )
    //     .required("Password cannot be blank!"),
});